import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import { savedEmailTemplateSchema } from "@redotech/redo-model/saved-email-template";

import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const getSavedEmailTemplateById = {
  input: z.object({ templateId: zExt.objectId() }),
  output: savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>,
};
